<template>
  <div :class="isFree" class="event shadow-sm">
    <div class="event__head">
      <div
        class="event__head-hora"
      >{{ event.start_time | formatDate }} - {{ event.end_time | formatDate }}</div>
      <div class="event__type" :style="{background: bgColor}">{{ event.type }}</div>
    </div>
    <div class="event__title">{{ event.title }}</div>
    <div class="event__palestrantes">
      <div class="palestrante">
        <div class="palestrante__name">
          <div v-for="(speaker, index) in speakers" :key="index" class="col-sm-12">
            <speaker :speaker="speaker"></speaker>
          </div>
        </div>
      </div>
    </div>
    <div class="event__footer">
      <div class="tracks" v-if="this.event.slot.tracks.length > 0 ">
        <span class="tracks__title">Tracks:</span>
        <span class="track" v-for="(track, index) in this.event.slot.tracks" :key="index">
          <span v-if="$route.params.language === 'pt'">{{ track.name_pt }}</span>
          <span v-else>{{ track.name_en }}</span>
        </span>
      </div>
      <a @click="select" class="more__info" data-toggle="modal" data-target="#eventInfo">
        <i class="fas fa-plus"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../main";
import Speaker from "./Speaker.vue";
export default {
  name: "Slot",
  props: ["event", "time"],
  data() {
    return {
      bgColor: this.event.type_color
    };
  },
  computed: {
    speakers() {
      if (this.event.type === "Painel de Debate") {
        return this.event.slot.coordinators;
      }
      return this.event.slot.keynote;
      // if (this.event.slot.coordinators) {
      //   return this.event.slot.coordinators;
      // }
      // return false;
    },
    contentFree() {
      $(function() {
        $('[data-toggle="tooltip"]').tooltip();
      });
      if (this.$route.params.language === "pt") {
        return "Conteúdo liberado para todo tipo de credencial";
      }
      if (this.$route.params.language === "en") {
        return "Content released for all types of credentials";
      }
      if (this.$route.params.language === "es") {
        return "Contenido liberado para todo tipo de credenciales";
      }
    },
    isFree() {
      return {
        free: this.event.free === 1,
        pay: this.event.free === 0
      };
    }
  },

  methods: {
    select(e) {
      eventBus.selectEvent(this.event);
    }
  },
  components: {
    Speaker
  }
};
</script>
<style lang="scss" scoped>
.event {
  color: #666;
  position: relative;
  border-radius: 6px;
  background-color: #fafafa;
  margin: 0 0 12px 0;
  z-index: 100;
  flex-wrap: wrap;
  white-space: normal;
  -ms-flex-wrap: wrap;
  // border: 1px solid #e5e5e5;

  &.free {
    border-left: 6px solid #4ae086;
  }
  &.pay {
    border-left: 6px solid #de636f;
  }

  &__head {
    letter-spacing: -4px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    &-hora {
      font-size: 10px;
      line-height: 14px;
      font-weight: bold;
      letter-spacing: 0;
      text-align: center;
      display: flex;
      padding: 6px 3px;
      vertical-align: top;
    }
    &-flags {
      height: 24px;
      display: flex;
      padding: 6px 3px 6px 6px;
      .flag {
        width: 12px;
        display: inline-block;
        margin: 0 2px 0 0;
        vertical-align: top;

        img {
          width: 100%;
          vertical-align: top;
          display: inline-block;
          margin: 2px 0 0 0;
        }
      }
    }
  }
  &__title {
    height: 24px;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0;
    display: inline-block;
    padding: 0 6px;
    overflow: hidden;
  }

  &__palestrantes {
    padding: 3px 6px;
    .palestrante {
      display: inline-block;

      &__img {
        display: none;
        img {
          width: 100%;
          border-radius: 6px;
        }
      }
      &__name {
        height: 20px;
        color: #666;
        font-size: 9px;
        line-height: 9px;
        padding: 3px 0;
        font-weight: bold;
        overflow: hidden;
        span {
          width: 100%;
          display: inline-block;
          font-size: 7px;
        }
      }
    }
  }
  &__footer {
    height: 52px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    overflow: hidden;
  }
  &__tags {
    width: calc(100% - 20px);
    padding: 3px 3px 12px 6px;
    font-size: 9px;
    line-height: 10px;
  }
  &__type {
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    line-height: 16px;
    letter-spacing: 0px;
    padding: 3px 4px;
    border-radius: 0 6px 0 6px;
  }
  .more__info {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    background-color: #17a2b8;
    i {
      color: #fff;
      margin: 6px 0 0 0;
    }
  }
  &.isView {
    width: 400px;
    z-index: 3690;
    background-color: #fff;
    .event__title {
      font-size: 12px;
      font-weight: bold;
    }
    .event__palestrantes {
      .palestrante {
        max-width: 50px;
        &__img {
          display: block;
        }
      }
    }
  }
}
.tracks {
  max-height: 30px;
}
.tracks__title {
  font-size: 10px;
  padding: 0 3px;
}
.track {
  color: #fff;
  max-height: 16px;
  font-size: 9px;
  line-height: 1;
  font-family: "Tahoma", Geneva, Verdana, sans-serif;
  padding: 2px;
  margin: 0 1px;
  background-color: #17a2b8;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/SlotEvent.vue